import { simpleGetRequest } from '@/api/requests';

const SETTINGS_BASE = 'globalsettings';

export default {
  getRegions: simpleGetRequest(`${SETTINGS_BASE}/regions`, {
    preventCancelRequest: true,
  }),
};
